export const loginScreenLoad = {
    event: "login_screen_load",
    eventAction: "login_screen_load"
};

export const termsOfUseCtaClick = {
    event: "NBFC_terms_of_use_cta_click",
    eventAction: "NBFC_terms_of_use_cta_click"
};

export const tuCibilCtaClick = {
    event: "NBFC_tu_cibil_terms_of_use_cta",
    eventAction: "NBFC_tu_cibil_terms_of_use_cta"
};
